import type { Template } from "../types/templates.types";

export const cleanProTemplate: Template = {
  id: "clean-pro-elite",
  name: "CleanPro Elite",
  description: "Professional cleaning services template with modern design and premium features",
  html: `<header class="cs-header">
  <div class="cs-container">
    <nav class="cs-nav">
      <div class="cs-logo">
        <svg class="cs-logo-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" stroke-width="2"/>
          <path d="M9 12l2 2 4-4" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span class="cs-logo-text">CleanPro</span>
      </div>
      <ul class="cs-nav-menu">
        <li class="cs-nav-item"><a href="#services" class="cs-nav-link">Services</a></li>
        <li class="cs-nav-item"><a href="#about" class="cs-nav-link">About</a></li>
        <li class="cs-nav-item"><a href="#pricing" class="cs-nav-link">Pricing</a></li>
        <li class="cs-nav-item"><a href="#testimonials" class="cs-nav-link">Reviews</a></li>
        <li class="cs-nav-item"><a href="#contact" class="cs-nav-link">Contact</a></li>
      </ul>
      <div class="cs-nav-actions">
        <a href="tel:+1234567890" class="cs-phone">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" stroke-width="2"/>
          </svg>
          <span>(123) 456-7890</span>
        </a>
        <button class="cs-btn cs-btn-primary">Get Free Quote</button>
      </div>
      <button class="cs-mobile-toggle" aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  </div>
</header>

<section class="cs-hero">
  <div class="cs-container">
    <div class="cs-hero-content">
      <div class="cs-hero-text">
        <span class="cs-hero-badge">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Trusted by 5,000+ Happy Clients
        </span>
        <h1 class="cs-hero-title">Professional Cleaning Services You Can Trust</h1>
        <p class="cs-hero-subtitle">Premium cleaning solutions for homes and businesses with certified staff, eco-friendly products, and 100% satisfaction guarantee.</p>
        <div class="cs-hero-buttons">
          <button class="cs-btn cs-btn-large cs-btn-primary">Book Cleaning Now</button>
          <button class="cs-btn cs-btn-large cs-btn-secondary">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="10" stroke-width="2"/>
              <path d="M10 8l6 4-6 4V8z" fill="currentColor"/>
            </svg>
            Watch Video
          </button>
        </div>
        <div class="cs-hero-stats">
          <div class="cs-stat">
            <span class="cs-stat-number">5,000+</span>
            <span class="cs-stat-label">Happy Clients</span>
          </div>
          <div class="cs-stat">
            <span class="cs-stat-number">15+</span>
            <span class="cs-stat-label">Years Experience</span>
          </div>
          <div class="cs-stat">
            <span class="cs-stat-number">98%</span>
            <span class="cs-stat-label">Satisfaction Rate</span>
          </div>
        </div>
      </div>
      <div class="cs-hero-image">
        <div class="cs-hero-img-wrapper">
          <div class="cs-hero-img-placeholder"></div>
          <div class="cs-hero-badge-float">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2"/>
            </svg>
            <div>
              <span class="cs-badge-title">Quality Guaranteed</span>
              <span class="cs-badge-subtitle">100% Satisfaction</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="cs-features">
  <div class="cs-container">
    <div class="cs-features-grid">
      <div class="cs-feature">
        <div class="cs-feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-feature-title">Insured & Bonded</h3>
        <p class="cs-feature-text">Fully licensed and insured for your complete peace of mind</p>
      </div>
      <div class="cs-feature">
        <div class="cs-feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-feature-title">Flexible Scheduling</h3>
        <p class="cs-feature-text">Book services at your convenience, 7 days a week</p>
      </div>
      <div class="cs-feature">
        <div class="cs-feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-feature-title">Quality Guaranteed</h3>
        <p class="cs-feature-text">100% satisfaction guarantee or we'll make it right</p>
      </div>
      <div class="cs-feature">
        <div class="cs-feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-feature-title">Eco-Friendly Products</h3>
        <p class="cs-feature-text">Green cleaning products safe for family and pets</p>
      </div>
    </div>
  </div>
</section>

<section id="services" class="cs-services">
  <div class="cs-container">
    <div class="cs-section-header">
      <span class="cs-section-tag">What We Offer</span>
      <h2 class="cs-section-title">Our Cleaning Services</h2>
      <p class="cs-section-subtitle">Comprehensive cleaning solutions tailored to meet your specific needs</p>
    </div>
    
    <div class="cs-services-grid">
      <div class="cs-service-card">
        <div class="cs-service-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke-width="2"/>
            <path d="M9 22V12h6v10" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-service-title">Residential Cleaning</h3>
        <p class="cs-service-description">Complete home maintenance for houses, apartments, and condos with meticulous attention to every detail.</p>
        <ul class="cs-service-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Deep room cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Kitchen & bathroom sanitization
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Vacuuming & disinfection
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Dusting & polishing
          </li>
        </ul>
        <button class="cs-btn cs-btn-service">Learn More →</button>
      </div>

      <div class="cs-service-card cs-featured">
        <div class="cs-featured-badge">Most Popular</div>
        <div class="cs-service-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-service-title">Commercial Cleaning</h3>
        <p class="cs-service-description">Professional cleaning services for offices, retail spaces, and corporate facilities to maintain a pristine environment.</p>
        <ul class="cs-service-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Office deep cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Common area maintenance
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            After-hours service
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Floor care & sanitization
          </li>
        </ul>
        <button class="cs-btn cs-btn-service cs-btn-primary">Learn More →</button>
      </div>

      <div class="cs-service-card">
        <div class="cs-service-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3 class="cs-service-title">Deep Cleaning</h3>
        <p class="cs-service-description">Intensive cleaning service perfect for move-ins, move-outs, post-renovation, or seasonal deep cleans.</p>
        <ul class="cs-service-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Post-construction cleanup
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Complete disinfection
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Windows & carpet cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Appliance deep clean
          </li>
        </ul>
        <button class="cs-btn cs-btn-service">Learn More →</button>
      </div>

      <div class="cs-service-card">
        <div class="cs-service-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke-width="2"/>
          </svg>
        </div>
        <h3 class="cs-service-title">Specialized Services</h3>
        <p class="cs-service-description">Custom cleaning solutions for unique needs including events, emergency cleanup, and specialized facilities.</p>
        <ul class="cs-service-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Event cleanup
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Medical facility cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Airbnb turnover service
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Custom packages
          </li>
        </ul>
        <button class="cs-btn cs-btn-service">Learn More →</button>
      </div>
    </div>
  </div>
</section>

<section class="cs-cta-banner">
  <div class="cs-container">
    <div class="cs-cta-content">
      <h2 class="cs-cta-title">Ready to Experience a Spotless Space?</h2>
      <p class="cs-cta-text">Get your free quote today and enjoy professional cleaning services</p>
      <button class="cs-btn cs-btn-large cs-btn-white">Get Free Quote Now</button>
    </div>
  </div>
</section>

<section id="pricing" class="cs-pricing">
  <div class="cs-container">
    <div class="cs-section-header">
      <span class="cs-section-tag">Pricing Plans</span>
      <h2 class="cs-section-title">Flexible Pricing Options</h2>
      <p class="cs-section-subtitle">Choose the plan that fits your cleaning needs and budget</p>
    </div>

    <div class="cs-pricing-grid">
      <div class="cs-pricing-card">
        <div class="cs-pricing-header">
          <h3 class="cs-pricing-name">Basic Clean</h3>
          <div class="cs-pricing-price">
            <span class="cs-price-currency">$</span>
            <span class="cs-price-amount">89</span>
            <span class="cs-price-period">/visit</span>
          </div>
          <p class="cs-pricing-description">Perfect for regular maintenance</p>
        </div>
        <ul class="cs-pricing-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            General cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Kitchen & bathroom
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Dusting & vacuuming
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Trash removal
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Up to 1,500 sq ft
          </li>
        </ul>
        <button class="cs-btn cs-btn-pricing">Choose Plan</button>
      </div>

      <div class="cs-pricing-card cs-popular">
        <div class="cs-popular-badge">Most Popular</div>
        <div class="cs-pricing-header">
          <h3 class="cs-pricing-name">Standard Clean</h3>
          <div class="cs-pricing-price">
            <span class="cs-price-currency">$</span>
            <span class="cs-price-amount">129</span>
            <span class="cs-price-period">/visit</span>
          </div>
          <p class="cs-pricing-description">Our most comprehensive package</p>
        </div>
        <ul class="cs-pricing-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Everything in Basic
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Deep cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Window cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Appliance cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Up to 2,500 sq ft
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Priority scheduling
          </li>
        </ul>
        <button class="cs-btn cs-btn-pricing cs-btn-primary">Choose Plan</button>
      </div>

      <div class="cs-pricing-card">
        <div class="cs-pricing-header">
          <h3 class="cs-pricing-name">Premium Clean</h3>
          <div class="cs-pricing-price">
            <span class="cs-price-currency">$</span>
            <span class="cs-price-amount">189</span>
            <span class="cs-price-period">/visit</span>
          </div>
          <p class="cs-pricing-description">Ultimate cleaning experience</p>
        </div>
        <ul class="cs-pricing-features">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Everything in Standard
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Carpet cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Upholstery cleaning
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Detailed organization
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Unlimited square footage
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 13l4 4L19 7" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Same-day service available
          </li>
        </ul>
        <button class="cs-btn cs-btn-pricing">Choose Plan</button>
      </div>
    </div>
  </div>
</section>

<section id="testimonials" class="cs-testimonials">
  <div class="cs-container">
    <div class="cs-section-header">
      <span class="cs-section-tag">Client Reviews</span>
      <h2 class="cs-section-title">What Our Clients Say</h2>
      <p class="cs-section-subtitle">Don't just take our word for it - hear from our satisfied customers</p>
    </div>

    <div class="cs-testimonials-grid">
      <div class="cs-testimonial-card">
        <div class="cs-testimonial-rating">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <p class="cs-testimonial-text">"CleanPro exceeded all my expectations! Their attention to detail is incredible, and my home has never looked better. The team is professional, punctual, and uses eco-friendly products. Highly recommend!"</p>
        <div class="cs-testimonial-author">
          <div class="cs-author-avatar">SJ</div>
          <div class="cs-author-info">
            <h4 class="cs-author-name">Sarah Johnson</h4>
            <p class="cs-author-title">Homeowner</p>
          </div>
        </div>
      </div>

      <div class="cs-testimonial-card">
        <div class="cs-testimonial-rating">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <p class="cs-testimonial-text">"We've been using CleanPro for our office for over a year now. They're reliable, thorough, and never miss a detail. Our employees always comment on how clean and fresh the office looks. Worth every penny!"</p>
        <div class="cs-testimonial-author">
          <div class="cs-author-avatar">MC</div>
          <div class="cs-author-info">
            <h4 class="cs-author-name">Michael Chen</h4>
            <p class="cs-author-title">Business Owner</p>
          </div>
        </div>
      </div>

      <div class="cs-testimonial-card">
        <div class="cs-testimonial-rating">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <p class="cs-testimonial-text">"I hired CleanPro for a deep clean after renovations, and they did an amazing job! Every corner was spotless, and they removed all the construction dust. Very impressed with their work ethic and results."</p>
        <div class="cs-testimonial-author">
          <div class="cs-author-avatar">ER</div>
          <div class="cs-author-info">
            <h4 class="cs-author-name">Emily Rodriguez</h4>
            <p class="cs-author-title">Apartment Resident</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="contact" class="cs-contact">
  <div class="cs-container">
    <div class="cs-contact-wrapper">
      <div class="cs-contact-info">
        <h2 class="cs-contact-title">Get Your Free Quote Today</h2>
        <p class="cs-contact-text">Ready to experience professional cleaning? Fill out the form and we'll get back to you within 24 hours with a customized quote.</p>
        
        <div class="cs-contact-details">
          <div class="cs-contact-item">
            <div class="cs-contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" stroke-width="2"/>
              </svg>
            </div>
            <div>
              <h4>Phone</h4>
              <p>(123) 456-7890</p>
            </div>
          </div>

          <div class="cs-contact-item">
            <div class="cs-contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke-width="2"/>
              </svg>
            </div>
            <div>
              <h4>Email</h4>
              <p>info@cleanpro.com</p>
            </div>
          </div>

          <div class="cs-contact-item">
            <div class="cs-contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" stroke-width="2"/>
                <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" stroke-width="2"/>
              </svg>
            </div>
            <div>
              <h4>Address</h4>
              <p>123 Clean Street, Suite 100<br>New York, NY 10001</p>
            </div>
          </div>

          <div class="cs-contact-item">
            <div class="cs-contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10" stroke-width="2"/>
                <path d="M12 6v6l4 2" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <h4>Working Hours</h4>
              <p>Mon - Fri: 8:00 AM - 8:00 PM<br>Sat - Sun: 9:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      <div class="cs-contact-form-wrapper">
        <form class="cs-contact-form">
          <div class="cs-form-row">
            <div class="cs-form-group">
              <label for="name">Full Name *</label>
              <input type="text" id="name" name="name" required placeholder="John Doe">
            </div>
            <div class="cs-form-group">
              <label for="email">Email Address *</label>
              <input type="email" id="email" name="email" required placeholder="john@example.com">
            </div>
          </div>

          <div class="cs-form-row">
            <div class="cs-form-group">
              <label for="phone">Phone Number *</label>
              <input type="tel" id="phone" name="phone" required placeholder="(123) 456-7890">
            </div>
            <div class="cs-form-group">
              <label for="service">Service Type *</label>
              <select id="service" name="service" required>
                <option value="">Select a service</option>
                <option value="residential">Residential Cleaning</option>
                <option value="commercial">Commercial Cleaning</option>
                <option value="deep">Deep Cleaning</option>
                <option value="specialized">Specialized Services</option>
              </select>
            </div>
          </div>

          <div class="cs-form-group">
            <label for="message">Message</label>
            <textarea id="message" name="message" rows="5" placeholder="Tell us about your cleaning needs..."></textarea>
          </div>

          <button type="submit" class="cs-btn cs-btn-large cs-btn-primary cs-btn-submit">Send Message</button>
        </form>
      </div>
    </div>
  </div>
</section>

<footer class="cs-footer">
  <div class="cs-container">
    <div class="cs-footer-top">
      <div class="cs-footer-col">
        <div class="cs-footer-logo">
          <svg class="cs-logo-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" stroke-width="2"/>
            <path d="M9 12l2 2 4-4" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span class="cs-logo-text">CleanPro</span>
        </div>
        <p class="cs-footer-description">Your trusted partner for professional cleaning services. We deliver excellence with every clean.</p>
        <div class="cs-footer-social">
          <a href="#" aria-label="Facebook">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a href="#" aria-label="Twitter">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
            </svg>
          </a>
          <a href="#" aria-label="Instagram">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
            </svg>
          </a>
          <a href="#" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
        </div>
      </div>

      <div class="cs-footer-col">
        <h3 class="cs-footer-title">Services</h3>
        <ul class="cs-footer-links">
          <li><a href="#services">Residential Cleaning</a></li>
          <li><a href="#services">Commercial Cleaning</a></li>
          <li><a href="#services">Deep Cleaning</a></li>
          <li><a href="#services">Specialized Services</a></li>
          <li><a href="#services">Move In/Out Cleaning</a></li>
        </ul>
      </div>

      <div class="cs-footer-col">
        <h3 class="cs-footer-title">Company</h3>
        <ul class="cs-footer-links">
          <li><a href="#about">About Us</a></li>
          <li><a href="#contact">Contact</a></li>
          <li><a href="#pricing">Pricing</a></li>
          <li><a href="#testimonials">Testimonials</a></li>
          <li><a href="#">Careers</a></li>
        </ul>
      </div>

      <div class="cs-footer-col">
        <h3 class="cs-footer-title">Support</h3>
        <ul class="cs-footer-links">
          <li><a href="#">FAQ</a></li>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Terms of Service</a></li>
          <li><a href="#">Cancellation Policy</a></li>
          <li><a href="#">Support Center</a></li>
        </ul>
      </div>
    </div>

    <div class="cs-footer-bottom">
      <p class="cs-footer-copyright">&copy; 2024 CleanPro Elite. All rights reserved.</p>
      <div class="cs-footer-payment">
        <span>We Accept:</span>
        <svg viewBox="0 0 24 24" fill="currentColor">
          <rect x="1" y="4" width="22" height="16" rx="2"/>
          <path d="M1 10h22" stroke="white" stroke-width="1"/>
        </svg>
      </div>
    </div>
  </div>
</footer>`,
  css: `:root {
  --cs-primary: #2563eb;
  --cs-primary-dark: #1d4ed8;
  --cs-primary-light: #3b82f6;
  --cs-secondary: #10b981;
  --cs-secondary-dark: #059669;
  --cs-accent: #f59e0b;
  --cs-dark: #1f2937;
  --cs-gray: #6b7280;
  --cs-gray-light: #f3f4f6;
  --cs-gray-medium: #e5e7eb;
  --cs-white: #ffffff;
  --cs-shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --cs-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  --cs-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  --cs-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  --cs-transition: all 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  line-height: 1.6;
  color: var(--cs-dark);
  background: var(--cs-white);
}

.cs-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header */
.cs-header {
  background: var(--cs-white);
  box-shadow: var(--cs-shadow);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.cs-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  gap: 2rem;
}

.cs-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--cs-primary);
  text-decoration: none;
}

.cs-logo-icon {
  width: 32px;
  height: 32px;
  stroke: var(--cs-primary);
}

.cs-nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
}

.cs-nav-link {
  color: var(--cs-dark);
  text-decoration: none;
  font-weight: 500;
  transition: var(--cs-transition);
  position: relative;
}

.cs-nav-link::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--cs-primary);
  transition: var(--cs-transition);
}

.cs-nav-link:hover {
  color: var(--cs-primary);
}

.cs-nav-link:hover::after {
  width: 100%;
}

.cs-nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.cs-phone {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--cs-dark);
  text-decoration: none;
  font-weight: 600;
}

.cs-phone svg {
  width: 20px;
  height: 20px;
  stroke: var(--cs-primary);
}

.cs-mobile-toggle {
  display: none;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.cs-mobile-toggle span {
  width: 24px;
  height: 3px;
  background: var(--cs-dark);
  transition: var(--cs-transition);
}

/* Buttons */
.cs-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--cs-transition);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.cs-btn-primary {
  background: var(--cs-primary);
  color: var(--cs-white);
}

.cs-btn-primary:hover {
  background: var(--cs-primary-dark);
  transform: translateY(-2px);
  box-shadow: var(--cs-shadow-lg);
}

.cs-btn-secondary {
  background: transparent;
  color: var(--cs-dark);
  border: 2px solid var(--cs-gray-medium);
}

.cs-btn-secondary:hover {
  border-color: var(--cs-primary);
  color: var(--cs-primary);
}

.cs-btn-large {
  padding: 1rem 2rem;
  font-size: 1.1rem;
}

.cs-btn-white {
  background: var(--cs-white);
  color: var(--cs-primary);
}

.cs-btn-white:hover {
  transform: translateY(-2px);
  box-shadow: var(--cs-shadow-xl);
}

/* Hero Section */
.cs-hero {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

.cs-hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.cs-hero-text {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cs-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--cs-white);
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--cs-secondary);
  width: fit-content;
  box-shadow: var(--cs-shadow);
}

.cs-hero-badge svg {
  width: 20px;
  height: 20px;
  stroke: var(--cs-secondary);
}

.cs-hero-title {
  font-size: 3rem;
  line-height: 1.2;
  color: var(--cs-dark);
  font-weight: 800;
}

.cs-hero-subtitle {
  font-size: 1.2rem;
  color: var(--cs-gray);
  line-height: 1.6;
}

.cs-hero-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.cs-hero-buttons svg {
  width: 20px;
  height: 20px;
}

.cs-hero-stats {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

.cs-stat {
  display: flex;
  flex-direction: column;
}

.cs-stat-number {
  font-size: 2rem;
  font-weight: 800;
  color: var(--cs-primary);
}

.cs-stat-label {
  font-size: 0.9rem;
  color: var(--cs-gray);
}

.cs-hero-image {
  position: relative;
}

.cs-hero-img-wrapper {
  position: relative;
}

.cs-hero-img-placeholder {
  width: 100%;
  height: 500px;
  background: linear-gradient(135deg, var(--cs-primary-light) 0%, var(--cs-primary) 100%);
  border-radius: 20px;
  box-shadow: var(--cs-shadow-xl);
}

.cs-hero-badge-float {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  background: var(--cs-white);
  padding: 1rem 1.5rem;
  border-radius: 12px;
  box-shadow: var(--cs-shadow-xl);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.cs-hero-badge-float svg {
  width: 40px;
  height: 40px;
  stroke: var(--cs-secondary);
}

.cs-badge-title {
  font-weight: 700;
  color: var(--cs-dark);
  display: block;
}

.cs-badge-subtitle {
  font-size: 0.9rem;
  color: var(--cs-gray);
}

/* Features Section */
.cs-features {
  padding: 4rem 0;
  background: var(--cs-white);
}

.cs-features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.cs-feature {
  text-align: center;
  padding: 2rem;
  border-radius: 12px;
  transition: var(--cs-transition);
}

.cs-feature:hover {
  background: var(--cs-gray-light);
  transform: translateY(-5px);
}

.cs-feature-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  background: linear-gradient(135deg, var(--cs-primary-light) 0%, var(--cs-primary) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs-feature-icon svg {
  width: 32px;
  height: 32px;
  stroke: var(--cs-white);
}

.cs-feature-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--cs-dark);
  margin-bottom: 0.5rem;
}

.cs-feature-text {
  color: var(--cs-gray);
}

/* Section Headers */
.cs-section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.cs-section-tag {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--cs-gray-light);
  color: var(--cs-primary);
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.cs-section-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--cs-dark);
  margin-bottom: 1rem;
}

.cs-section-subtitle {
  font-size: 1.1rem;
  color: var(--cs-gray);
  max-width: 600px;
  margin: 0 auto;
}

/* Services Section */
.cs-services {
  padding: 4rem 0;
  background: var(--cs-gray-light);
}

.cs-services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.cs-service-card {
  background: var(--cs-white);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: var(--cs-shadow);
  transition: var(--cs-transition);
  position: relative;
  display: flex;
  flex-direction: column;
}

.cs-service-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--cs-shadow-xl);
}

.cs-service-card.cs-featured {
  border: 2px solid var(--cs-primary);
}

.cs-featured-badge {
  position: absolute;
  top: -12px;
  right: 20px;
  background: var(--cs-primary);
  color: var(--cs-white);
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 700;
  box-shadow: var(--cs-shadow);
}

.cs-service-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, var(--cs-primary-light) 0%, var(--cs-primary) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.cs-service-icon svg {
  width: 32px;
  height: 32px;
  stroke: var(--cs-white);
}

.cs-service-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--cs-dark);
  margin-bottom: 1rem;
}

.cs-service-description {
  color: var(--cs-gray);
  margin-bottom: 1.5rem;
  flex-grow: 1;
}

.cs-service-features {
  list-style: none;
  margin-bottom: 1.5rem;
}

.cs-service-features li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--cs-gray);
}

.cs-service-features svg {
  width: 20px;
  height: 20px;
  stroke: var(--cs-secondary);
  flex-shrink: 0;
}

.cs-btn-service {
  width: 100%;
  background: var(--cs-gray-light);
  color: var(--cs-dark);
}

.cs-btn-service:hover {
  background: var(--cs-primary);
  color: var(--cs-white);
}

/* CTA Banner */
.cs-cta-banner {
  padding: 4rem 0;
  background: linear-gradient(135deg, var(--cs-primary) 0%, var(--cs-primary-dark) 100%);
  text-align: center;
}

.cs-cta-content {
  max-width: 800px;
  margin: 0 auto;
}

.cs-cta-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--cs-white);
  margin-bottom: 1rem;
}

.cs-cta-text {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
}

/* Pricing Section */
.cs-pricing {
  padding: 4rem 0;
  background: var(--cs-white);
}

.cs-pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.cs-pricing-card {
  background: var(--cs-white);
  border: 2px solid var(--cs-gray-medium);
  border-radius: 16px;
  padding: 2rem;
  transition: var(--cs-transition);
  position: relative;
}

.cs-pricing-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--cs-shadow-xl);
  border-color: var(--cs-primary);
}

.cs-pricing-card.cs-popular {
  border-color: var(--cs-primary);
  border-width: 3px;
}

.cs-popular-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--cs-primary);
  color: var(--cs-white);
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 700;
}

.cs-pricing-header {
  text-align: center;
  padding-bottom: 2rem;
  border-bottom: 2px solid var(--cs-gray-medium);
  margin-bottom: 2rem;
}

.cs-pricing-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--cs-dark);
  margin-bottom: 1rem;
}

.cs-pricing-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.25rem;
  margin-bottom: 1rem;
}

.cs-price-currency {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--cs-dark);
}

.cs-price-amount {
  font-size: 3rem;
  font-weight: 800;
  color: var(--cs-primary);
}

.cs-price-period {
  font-size: 1rem;
  color: var(--cs-gray);
}

.cs-pricing-description {
  color: var(--cs-gray);
}

.cs-pricing-features {
  list-style: none;
  margin-bottom: 2rem;
}

.cs-pricing-features li {
  padding: 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--cs-dark);
}

.cs-pricing-features svg {
  width: 20px;
  height: 20px;
  stroke: var(--cs-secondary);
  flex-shrink: 0;
}

.cs-btn-pricing {
  width: 100%;
  background: var(--cs-gray-light);
  color: var(--cs-dark);
}

.cs-btn-pricing:hover {
  background: var(--cs-primary);
  color: var(--cs-white);
}

/* Testimonials Section */
.cs-testimonials {
  padding: 4rem 0;
  background: var(--cs-gray-light);
}

.cs-testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
}

.cs-testimonial-card {
  background: var(--cs-white);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: var(--cs-shadow);
  transition: var(--cs-transition);
}

.cs-testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--cs-shadow-xl);
}

.cs-testimonial-rating {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1rem;
}

.cs-testimonial-rating svg {
  width: 20px;
  height: 20px;
  fill: var(--cs-accent);
}

.cs-testimonial-text {
  color: var(--cs-dark);
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.cs-testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.cs-author-avatar {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--cs-primary-light) 0%, var(--cs-primary) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cs-white);
  font-weight: 700;
  flex-shrink: 0;
}

.cs-author-name {
  font-weight: 700;
  color: var(--cs-dark);
}

.cs-author-title {
  font-size: 0.9rem;
  color: var(--cs-gray);
}

/* Contact Section */
.cs-contact {
  padding: 4rem 0;
  background: var(--cs-white);
}

.cs-contact-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
}

.cs-contact-title {
  font-size: 2rem;
  font-weight: 800;
  color: var(--cs-dark);
  margin-bottom: 1rem;
}

.cs-contact-text {
  color: var(--cs-gray);
  margin-bottom: 2rem;
}

.cs-contact-details {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cs-contact-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.cs-contact-icon {
  width: 48px;
  height: 48px;
  background: var(--cs-gray-light);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cs-contact-icon svg {
  width: 24px;
  height: 24px;
  stroke: var(--cs-primary);
}

.cs-contact-item h4 {
  font-weight: 700;
  color: var(--cs-dark);
  margin-bottom: 0.25rem;
}

.cs-contact-item p {
  color: var(--cs-gray);
  line-height: 1.6;
}

.cs-contact-form-wrapper {
  background: var(--cs-gray-light);
  padding: 2rem;
  border-radius: 16px;
}

.cs-contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cs-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.cs-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cs-form-group label {
  font-weight: 600;
  color: var(--cs-dark);
}

.cs-form-group input,
.cs-form-group select,
.cs-form-group textarea {
  padding: 0.75rem 1rem;
  border: 2px solid var(--cs-gray-medium);
  border-radius: 8px;
  font-family: inherit;
  font-size: 1rem;
  transition: var(--cs-transition);
  background: var(--cs-white);
}

.cs-form-group input:focus,
.cs-form-group select:focus,
.cs-form-group textarea:focus {
  outline: none;
  border-color: var(--cs-primary);
}

.cs-btn-submit {
  margin-top: 1rem;
}

/* Footer */
.cs-footer {
  background: var(--cs-dark);
  color: var(--cs-white);
  padding: 3rem 0 1rem;
}

.cs-footer-top {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.cs-footer-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--cs-white);
  margin-bottom: 1rem;
}

.cs-footer-logo .cs-logo-icon {
  stroke: var(--cs-white);
}

.cs-footer-description {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.cs-footer-social {
  display: flex;
  gap: 1rem;
}

.cs-footer-social a {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cs-white);
  transition: var(--cs-transition);
}

.cs-footer-social a:hover {
  background: var(--cs-primary);
  transform: translateY(-3px);
}

.cs-footer-social svg {
  width: 20px;
  height: 20px;
}

.cs-footer-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--cs-white);
}

.cs-footer-links {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cs-footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: var(--cs-transition);
}

.cs-footer-links a:hover {
  color: var(--cs-white);
  padding-left: 5px;
}

.cs-footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
}

.cs-footer-copyright {
  color: rgba(255, 255, 255, 0.6);
}

.cs-footer-payment {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: rgba(255, 255, 255, 0.6);
}

.cs-footer-payment svg {
  width: 40px;
  height: 24px;
  fill: var(--cs-white);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .cs-hero-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .cs-hero-title {
    font-size: 2.5rem;
  }

  .cs-services-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cs-features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cs-contact-wrapper {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .cs-footer-top {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .cs-nav-menu {
    display: none;
  }

  .cs-phone {
    display: none;
  }

  .cs-mobile-toggle {
    display: flex;
  }

  .cs-hero-title {
    font-size: 2rem;
  }

  .cs-hero-subtitle {
    font-size: 1rem;
  }

  .cs-hero-stats {
    flex-direction: column;
    gap: 1rem;
  }

  .cs-features-grid {
    grid-template-columns: 1fr;
  }

  .cs-services-grid {
    grid-template-columns: 1fr;
  }

  .cs-section-title {
    font-size: 2rem;
  }

  .cs-form-row {
    grid-template-columns: 1fr;
  }

  .cs-pricing-grid {
    grid-template-columns: 1fr;
  }

  .cs-testimonials-grid {
    grid-template-columns: 1fr;
  }

  .cs-footer-top {
    grid-template-columns: 1fr;
  }

  .cs-footer-bottom {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .cs-cta-title {
    font-size: 1.8rem;
  }

  .cs-hero-buttons {
    flex-direction: column;
  }

  .cs-btn-large {
    width: 100%;
  }
}`,
  thumbnailUrl: 'https://flownect-media-dev.s3.us-west-1.amazonaws.com/templates-images/clean-pro.png',
  blocks: [],
};